import { Provider } from "mobx-react";
import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router";
import { createBrowserRouter } from "react-router-dom";
import {
  AdminPage,
  AuthPage,
  CreateMaster,
  CreateProduct,
  CreateService,
  DefaultPage,
  DeleteMaster,
  DeleteProduct,
  DeleteService,
  EditMaster,
  EditProduct,
  EditService,
  InputPhonePage,
  OrderPage,
  RegisterClientPage,
  ReportAdminPage,
  ReportPage,
  SelectMasterPage,
  SelectServicePage,
  Stat,
  StatMonth,
  StatToday,
} from "./pages";
import reportWebVitals from "./reportWebVitals";
import Store from "./store";
import "./style.css";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

const router = createBrowserRouter([
  { path: "/", element: <AuthPage /> },
  { path: "/admin", element: <AdminPage title="Админ-панель" /> },
  { path: "/admin/master/create", element: <CreateMaster title="Добавить мастера" /> },
  { path: "/admin/master/edit", element: <EditMaster title="Редактировать мастера" /> },
  { path: "/admin/master/delete", element: <DeleteMaster title="Удалить мастера" /> },
  { path: "/admin/service/create", element: <CreateService title="Добавить услугу" /> },
  { path: "/admin/service/edit", element: <EditService title="Изменить услугу" /> },
  { path: "/admin/service/delete", element: <DeleteService title="Удалить услугу" /> },
  { path: "/admin/product/create", element: <CreateProduct title="Добавить продукт" /> },
  { path: "/admin/product/edit", element: <EditProduct title="Добавить мастера" /> },
  { path: "/admin/product/delete", element: <DeleteProduct title="Добавить мастера" /> },
  { path: "/default", element: <DefaultPage title="Добро пожаловать" /> },
  { path: "/default/master", element: <SelectMasterPage title="Выберите мастера" /> },
  { path: "/default/services", element: <SelectServicePage title="Выберите услугу" /> },
  { path: "/default/phone", element: <InputPhonePage title="Ввод номера" /> },
  { path: "/default/reg", element: <RegisterClientPage title="Регистрация клиента" /> },
  { path: "/default/order", element: <OrderPage title="Чек" /> },
  { path: "/default/report", element: <ReportPage title="Дневной отчет" /> },
  { path: "/admin/stat/today", element: <StatToday title="Статистика за сегодня" /> },
  { path: "/admin/stat/month", element: <StatMonth title="Статистика за месяц" /> },
  { path: "/admin/stat/all", element: <Stat title="Статистика" />},
  { path: "/admin/stat/reports", element: <ReportAdminPage title="Отчеты" />}
]);
const store = new Store();

export const Context = React.createContext({ store });

if (localStorage.token) store.uploadData();

root.render(
  <Provider value={{ store }}>
    <RouterProvider router={router} />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
